module.exports = __webpack_public_path__ + "img/justin.eed25605.jpg";